import { ReactComponentElement } from "react";

import { Nullable } from "../../../types/common";

export const ListingTableMidHeader = "meta-mid-header";

export type TTableLink = (row: TRow) => string;

export interface TRow {
  [prop: string]: any;
  [ListingTableMidHeader]?: boolean;
}

export interface TCol {
  customComponent?: ReactComponentElement<any>;
  headerVariant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  label: string;
  key: string;
  render?: (row: TRow, link?: TTableLink) => Nullable<string | ReactComponentElement<any>>;
  stopPropagation?: boolean;
}

export interface IListingTable {
  className?: string;
  close?: () => void;
  columns: TCol[];
  dataList: TRow[];
  headers?: boolean;
  link?: TTableLink;
  noResultsMessage?: string;
  minFirstColumnWidth?: string;
}
